// Auto-generated by scripts/generate-image-metadata.mjs
// Do not edit manually

export interface ImageDimensions {
    width: number;
    height: number;
}

export const imageMetadata: Record<string, ImageDimensions> = {};

/**
 * Get dimensions for an image by its relative path from src/assets
 */
export function getImageDimensions(relativePath: string): ImageDimensions | undefined {
    return imageMetadata[relativePath];
}
